import styled from 'styled-components/macro';
const Menu = styled.ul `
  margin: 0;
  padding: 0;
`;
export { Menu };
